import { Component, Input, OnInit, Inject } from "@angular/core";

import { WorkplaceDataService } from "../../../core/workplaces.dataservice";
import { CrewPermissionsService } from "../../../core/crew-permissions.service";

@Component({
    selector: "crew-person-workplaces",
    template: require('./person.workplaces.component.html')
})
export class PersonWorkplacesComponent implements OnInit {

    isPermissionWriteOrAdmin: boolean;

    constructor(
        @Inject(WorkplaceDataService.Id) private workplaceDataService: WorkplaceDataService,
        private crewPermissionsService: CrewPermissionsService) {
    }

    workplaces: Nema.Crew.Model.Workplace[];

    @Input()
    person: Nema.Crew.Model.Person;

    ngOnInit() {
        this.crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);
        
        this.workplaceDataService
            .getAll()
            .then(res => {
                this.workplaces = res;

                (<any>this.person.PersonWorkplaces).load();
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/workplaces/person.workplaces.component.ts